import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Dialog from '../../../core/layout/Dialog';
import Separator from '../../../core/layout/Separator';
import Divider from '../../../core/layout/Divider';
import TextInput from '../../../core/form/TextInput';
import FormButtons from '../../../core/form/FormButtons';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';

const CreateMasteryTestItemDraftDialog = (props) => (
  <Dialog title="Create Draft" isOpen={props.isOpen} onCancel={props.onCancel} actions={null} width={1000}>
    <div>
      <b>Module</b>: <span>{props.masteryTestItem.masteryTest.module.name}</span>
    </div>
    <Separator size="xxs" />
    <div>
      <b>Mastery Test</b>: <span>{props.masteryTestItem.masteryTest.modulePercentageToActive}%</span>
    </div>
    <Separator size="xxs" />
    <div>
      <b>Order</b>: <span>{props.masteryTestItem.order}</span>
    </div>
    <Separator size="xxs" />
    <div>
      <b>Text</b>: <span>{props.masteryTestItem.item.text}</span>
    </div>
    <Separator size="sm" />
    <Divider title="" />
    <form
      onSubmit={(event) => {
        event.preventDefault();
        props.onSubmit();
      }}
    >
      <Row>
        <Column size={12}>
          <TextInput
            required
            label="What is the change reason?"
            fieldType="textarea"
            disabled={props.submitting || props.disabled}
            value={get(props.values, 'draftCreationReason', '')}
            onChange={(value) => props.onChange('draftCreationReason', value)}
            errorText={get(props.errors, 'draftCreationReason', '')}
            textAreaRows="4"
          />
        </Column>
      </Row>
      <Separator size="xs" />
      <FormButtons
        confirmLabel="Create"
        isDisabled={props.submitting || !props.isDirty()}
        isSubmitting={props.submitting}
        onReset={props.onCancel}
      />
    </form>
  </Dialog>
);

CreateMasteryTestItemDraftDialog.propTypes = {
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  masteryTestItem: PropTypes.shape({
    masteryTest: PropTypes.shape({
      modulePercentageToActive: PropTypes.number.isRequired,
      module: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    item: PropTypes.shape({
      text: PropTypes.string.isRequired,
    }).isRequired,
    order: PropTypes.number.isRequired,
  }),
  onSubmit: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  isDirty: PropTypes.func,
};

CreateMasteryTestItemDraftDialog.defaultProps = {
  isOpen: false,
};

export default CreateMasteryTestItemDraftDialog;
